<template>
  <div v-bind:class="{
      notification: true,
      hide: !notification.show,
      disabled: notification.isLoading
    }" @click="loadData">
    <i v-bind:class="{ 'fas fa-sync': true, 'fa-spin': notification.isLoading }"></i>
    <span>{{ notification.text }}</span>
  </div>
</template>

<script>
import ApiDispatchReservation from '@/modules/api/dispatch/reservations'
export default {
  name: 'notification-new-booking',
  computed: {
    notification () {
      return this.$store.state.dispatch.notificationNewBooking
    }
  },
  methods: {
    loadData () {
      let self = this
      ApiDispatchReservation.updateReservationTable(self, self.notification.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.notification {
  background-color: #e2f0ff;
  display: block;
  color: #0D79F2;
  border: 1px solid #0D79F2;
  padding: 15px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
  transition: all 250ms;
  height: 51px;
  overflow: hidden;
  border-left: 0;
  border-right: 0;

  &.hide{
    height: 0;
    padding: 0 15px;
    border: 0;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dispatch/NotificationNewBooking.vue